'use client';

interface Step1Props {
  onNext: () => void;
}

export default function Step1Landing({ onNext }: Step1Props) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 animate-fade-in">
      <div className="text-center max-w-2xl">
        <div className="mb-6">
          <span className="inline-block bg-primary-light text-primary px-4 py-1.5 rounded-full text-sm font-medium">
            Gratuit &middot; 60 secondes
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-6 leading-tight">
          Créez vos <span className="text-primary">emails professionnels</span> en quelques clics
        </h1>

        <p className="text-lg text-muted mb-4 max-w-lg mx-auto">
          Découvrez si votre nom de domaine est disponible et générez vos
          adresses emails professionnelles maintenant.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-sm text-muted mb-10">
          <span className="flex items-center gap-1.5">
            <span className="text-success">&#10003;</span> Vérification instantanée
          </span>
          <span className="flex items-center gap-1.5">
            <span className="text-success">&#10003;</span> Preview en temps réel
          </span>
          <span className="flex items-center gap-1.5">
            <span className="text-success">&#10003;</span> Installation incluse
          </span>
        </div>

        <button
          onClick={onNext}
          className="bg-primary hover:bg-primary-hover text-white font-semibold text-lg px-10 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 cursor-pointer"
        >
          Commencer
        </button>

        <p className="mt-6 text-xs text-muted">
          Aucune carte bancaire requise pour la simulation
        </p>
      </div>
    </div>
  );
}